<template>
  <div id="app">
    <div style="text-align: center">
      <img class="poster-logo" :src="posterLogo" alt="" />
    </div>
    <div v-if="language === 'cn' || language === 'tw'">
      <div class="title">
        {{ $t("posterPage.title1") }}
      </div>
      <div style="text-align: center">
        <img class="poster-tip" :src="posterTip" alt="" />
      </div>
      <div class="poster-tip-text">
        <span>{{ $t("posterPage.title2") }}</span>
      </div>
      <div style="text-align: center">
        <img class="beijing-icon" :src="beijingIcon" alt="" />
      </div>
      <div class="sale-text">{{ $t("posterPage.title3") }}</div>
      <div class="content">
        <div class="content-title">{{ $t("posterPage.title5") }}</div>
        <div class="content-item1">{{ $t("posterPage.title4") }}</div>
        <div class="content-item2">
          <div>{{ $t("posterPage.function1") }}</div>
          <div>{{ $t("posterPage.function2") }}</div>
          <div>{{ $t("posterPage.function3") }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="title-en">
        {{ $t("posterPage.title1") }}
      </div>
      <div class="poster-tip-text-en" :style="{'paddingLeft':posterTipPadding,'height':posterTipHeight,'textAlign': posterTextAlign}">
        <span>{{ $t("posterPage.title2") }}</span>
      </div>
      <div style="text-align: center">
        <img class="beijing-icon" :src="beijingIcon" alt="" />
      </div>
      <div class="sale-text-en">{{ $t("posterPage.title3") }}</div>
      <div class="content-en">
        <div class="content-title-en" :style="{ 'width': contentWidth,'paddingLeft':contentPaddingLeft }">
          {{ $t("posterPage.title5") }}
        </div>
        <div class="content-item1">{{ $t("posterPage.title4") }}</div>
        <div class="content-item2">
          <div>{{ $t("posterPage.function1") }}</div>
          <div>{{ $t("posterPage.function2") }}</div>
          <div>{{ $t("posterPage.function3") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentPaddingLeft:'16px',
      posterTipPadding:"0px",
      posterTipHeight:'44px',
      contentWidth: "230px",
      posterTextAlign:"center",
      language: "cn",
      posterLogo: require("@/assets/poster-logo.png"),
      posterTip: require("@/assets/poster-tip.png"),
      beijingIcon: require("@/assets/beijing-icon.png"),
    };
  },
  async mounted() {
    const language = this.$route.query.language;
    if (!language) {
      localStorage.setItem("lang", "cn");
      this.$i18n.locale = "cn";
      await this.setLanguage();
      return;
    }
    await this.getAppLanguage(language);
    this.language = localStorage.getItem("lang") || 'cn';
    this.getContentWidth()
  },
  methods: {
    getAppLanguage(language) {
      if (language.startsWith("zh")) {
        if (language.startsWith("zh_CN")) {
          localStorage.setItem("lang", "cn");
          this.$i18n.locale = "cn";
        }
        if (language.startsWith("zh_TW")) {
          localStorage.setItem("lang", "tw");
          this.$i18n.locale = "tw";
        }

        return;
      }
      if (language.startsWith("en")) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return;
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return;
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return;
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return;
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return;
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return;
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return;
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return;
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return;
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return;
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return;
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return;
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return;
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return;
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return;
      }
      if (language.startsWith("fa")) {
        localStorage.setItem("lang", "fa");
        this.$i18n.locale = "fa";
        return;
      }
    },
    setLanguage() {
      let language = this.getPreferredLanguage();
      if (language.startsWith("zh")) {
        if (language.startsWith("zh_CN")) {
          localStorage.setItem("lang", "cn");
          this.$i18n.locale = "cn";
        }
        if (language.startsWith("zh_TW")) {
          localStorage.setItem("lang", "tw");
          this.$i18n.locale = "tw";
        }
        return;
      }
      if (language.startsWith("en")) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return;
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return;
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return;
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return;
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return;
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return;
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return;
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return;
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return;
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return;
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return;
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return;
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return;
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return;
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return;
      }
      if (language.startsWith("fa")) {
        localStorage.setItem("lang", "fa");
        this.$i18n.locale = "fa";
        return;
      }
    },
    getPreferredLanguage() {
      return navigator.language || navigator.userLanguage;
    },
    getContentWidth() {
      if (this.language === "ru" || this.language === "it") {
        this.contentWidth = "270px";
      } else if(this.language === 'ja' || this.language === 'ko' || this.language === 'ar'){
        this.contentWidth = "150px";
      } else if(this.language === 'fr'){
        this.contentWidth = "320px";
        this.posterTipPadding = '16px'
        this.posterTipHeight = '64px'
        this.posterTextAlign = 'left'
        this.contentPaddingLeft = '0px'
      } else if(this.language === 'de'){
        this.contentWidth = "280px";
      } else if(this.language === 'pt'){
        this.contentWidth = "285px";
      } else if(this.language === 'vi'){
        this.contentWidth = '250px'
      } else if(this.language === 'fa'){
        this.contentWidth = '100px'
      }
      else {
        this.contentWidth = "230px";
      }
    },
  },
};
</script>

<style scoped>
#app {
  height: 100vh;
  width: 100%;
  text-align: left;
  background-image: url("../assets/beijing.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  background-color: #efedec;
  overflow-y: auto;
  overflow-x: hidden;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.poster-logo {
  width: 120px;
  height: 132px;
  margin-top: -30px;
}
.title {
  font-family: Source Han Sans;
  font-size: 36px;
  font-weight: 900;
  line-height: 45px;
  letter-spacing: normal;
  background: linear-gradient(7deg, #d61c14 26%, #a11a12 83%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-align: center;
  padding-left: 10px;
  margin-top: -40px;
}
.poster-tip {
  width: 183px;
  height: 44px;
  margin-top: 14px;
}
.poster-tip-text {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  color: #ffffff;
  text-align: center;
  margin-top: -43px;
}
.sale-text {
  width: 100%;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0.28em;
  color: #782727;
  text-align: center;
  margin-top: -50px;
}
.content {
  width: calc(100% - 48px);
  min-height: 177px;
  border-radius: 16px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #ffdbd3;
  text-align: center;
  margin: 16px 24px;
}
.content-title {
  width: 178px;
  height: 34px;
  background-image: url("../assets/juxing.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 16px 0px;

  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  line-height: 34px;
  letter-spacing: normal;
  color: #ffffff;
}
.content-title-en {
  height: 34px;
  background-image: url("../assets/juxing-en.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 16px 0px;

  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 34px;
  letter-spacing: normal;
  color: #ffffff;
  padding-left: 16px;
}
.content-item1 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #3a0d0a;
  padding-left: 16px;
}
.content-item2 {
  min-width: 287px;
  min-height: 61px;
  border-radius: 8px;
  background: #f4f2f1;
  margin: 8px 16px;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  text-align: left;
  padding: 10px 0px 10px 10px;
}

.title-en {
  font-family: Source Han Sans;
  font-size: 28.7px;
  font-weight: 900;
  line-height: 35px;
  text-align: center;
  letter-spacing: normal;
  background: linear-gradient(4deg, #d61c14 8%, #a11a12 91%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  margin-top: -40px;
}
.poster-tip-text-en {
  box-sizing: border-box;
  width: 328px;
  height: 44px;
  font-family: Source Han Sans;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
  background-image: url("../assets/poster-tip-en.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 8px;
  margin: 16px auto 0px;
}
.sale-text-en {
  width: 274px;
  height: 48px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  color: #782727;
  margin: -50px auto 0px;
}
.content-en {
  width: calc(100% - 48px);
  min-height: 250px; 
  border-radius: 16px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #ffdbd3;
  margin: 8px auto;
}
.beijing-icon {
  width: 376px;
  height: 365px;
  margin-top: 24px;
}
</style>